import React from "react";
import { useTranslation } from "react-i18next";
import LoginWrapper from "./LoginWrapper";
import SvgIcon from "../parts/SvgIcon";
import BackArrowButton from "../parts/back-arrow-button";

function LoginPasswordViewInner(props) {
  const { t } = useTranslation("auth");
  const {
    handlePasswordChange,
    handlePasswordLogin,
    email,
    handleEmailChange,
    onBack,
  } = props;
  const [passwordType, setPasswordType] = React.useState("password");

  React.useEffect(() => {
    document.querySelector('input[name="password"]')?.focus();
  }, []);

  const changePasswordType = (e) => {
    e.preventDefault();
    setPasswordType((prev) => (prev === "password" ? "text" : "password"));
  };

  return (
    <LoginWrapper
      left={
        <form method="POST" data-noreset>
          <BackArrowButton onBack={(_) => onBack(0)} />
          <div>
            <h1>{t("loginPassword.title")}</h1>
          </div>
          <label htmlFor="email">{t("loginPassword.emailLabel")}</label>
          <input
            type="email"
            name="email"
            value={email}
            required
            onChange={handleEmailChange}
            placeholder={t("loginPassword.emailPlaceholder")}
            sz="large"
          />

          <div className="input-password-wrapper">
            <label htmlFor="password">{t("loginPassword.passwordLabel")}</label>
            <input
              type={passwordType}
              name="password"
              required
              onChange={handlePasswordChange}
              placeholder={t("loginPassword.passwordPlaceholder")}
              sz="large"
            />

            <button
              data-button-type="text-white"
              data-icon-only=""
              onClick={changePasswordType}
              tabIndex="-1"
              type="button"
              sz="large"
            >
              <SvgIcon
                src={
                  passwordType === "password"
                    ? "/img/new-icons/eye.svg"
                    : "/img/new-icons/eye-slash.svg"
                }
                alt={t("loginPassword.eyeAlt")}
              />
            </button>
          </div>

          <button
            data-button-type="primary"
            type="submit"
            sz="large"
            onClick={handlePasswordLogin}
          >
            {t("loginPassword.continue")}
          </button>

          <a data-button-type="text-white" href={`/forgot?email=${email}`}>
            {t("loginPassword.forgotPassword")}
          </a>
        </form>
      }
    />
  );
}

export default LoginPasswordViewInner;
